import { ReactNode } from "react";
import Box from "@mui/material/Box";

interface StickyActionBarProps {
  children: ReactNode;
  visible?: boolean;
}

export default function StickyActionBar({ children, visible = true }: StickyActionBarProps) {
  if (!visible) return null;

  return (
    <Box
      sx={{
        position: "sticky",
        bottom: 0,
        zIndex: 10,
        backgroundColor: "#fff",
        borderTop: "1px solid #ccc",
        padding: "12px 16px",
        // Two equal columns so 3–4 actions fit a 375 px portrait viewport; an
        // odd trailing action spans the full width. 1 or 2 actions → one row.
        display: "grid",
        gridTemplateColumns: "1fr 1fr",
        gap: "12px",
        "& > *": { minWidth: 0 },
        "& > *:last-child:nth-of-type(odd)": { gridColumn: "1 / -1" },
      }}
    >
      {children}
    </Box>
  );
}
